import { FC, ReactNode } from 'react';

import { Title, TitleProps, VSpacingContainer } from '@hh.ru/magritte-ui';

interface Props {
    title: string;
    titleAlignment?: TitleProps['alignment'];
    children: ReactNode;
}

const FAQContainer: FC<Props> = ({ title, titleAlignment, children }) => (
    <VSpacingContainer default={24}>
        <Title Element="h2" size="medium" alignment={titleAlignment}>
            {title}
        </Title>
        <VSpacingContainer default={16}>{children}</VSpacingContainer>
    </VSpacingContainer>
);

export default FAQContainer;
